import { render, staticRenderFns } from "./EggNewData.vue?vue&type=template&id=d56c3134"
import script from "./EggNewData.vue?vue&type=script&lang=js"
export * from "./EggNewData.vue?vue&type=script&lang=js"
import style0 from "./EggNewData.vue?vue&type=style&index=0&id=d56c3134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports